var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Subtitle',{staticStyle:{"height":"15%"},attrs:{"subtitle":_vm.rightObj.subTitle}}),_c('EchartsCom',{ref:"rightEcharts03",staticStyle:{"height":"85%"},attrs:{"parmas":_vm.rightObj.parmas}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }